var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#27A376",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_12451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9079 11.4102L23.1377 13.652H16.6995L16.9293 11.4102H14.7318L13.6367 18.1618H17.4001C17.6249 17.3221 18.6846 16.7038 19.9982 16.7038C21.3117 16.7038 22.3714 17.3221 22.5962 18.1618H26.1915L24.9887 11.4102H22.9079Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 20.2899C18.6862 20.2899 17.6265 19.6717 17.4017 18.832H13.5302L11.9883 28.337H15.5097L15.8431 25.0857H24.1566L24.4901 28.337H28.0051L26.3117 18.8323H22.5977C22.3729 19.6717 21.3136 20.2899 19.9997 20.2899Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2436 11.4414H17.5998L17.4414 12.9863H22.402L22.2436 11.4414Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4448 25.75L16.1797 28.3343H23.8189L23.5538 25.75H16.4448Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0012 19.623C20.8695 19.623 21.6285 19.2849 21.8853 18.832H18.1172C18.3739 19.2849 19.1328 19.623 20.0012 19.623Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 17.3711C19.1329 17.3711 18.3739 17.7092 18.1172 18.162H21.8853C21.6285 17.7092 20.8699 17.3711 20.0013 17.3711Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3956 10.0781L10 29.9191H30L26.2709 10.0781H13.3956ZM24.5586 29.002H15.4414H11.2048L14.1663 10.745H25.5489L28.8012 29.002H24.5586Z",
    fill: "#27A376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_12451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/football.95cf34f5836eec29d16caa359940216b.svg";
export { ForwardRef as ReactComponent };